import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerAndAddressHeader } from 'src/app/models/customer-address/customer-and-address-header';
import { PostExistingCustomerProspectCustomerAddressCreate } from 'src/app/models/customer-address/post-existing-customer-prospect-customer-address-create';
import { PostProspectCustomerAddressCreate } from 'src/app/models/customer-address/post-prospect-customer-address-create';
import { PostProspectCustomerAddressUpdate } from 'src/app/models/customer-address/post-prospect-customer-address-update';
import { ResponseCreateCustomerAddress } from 'src/app/models/customer-address/response-create-customer-address';
import { ReturnGenericAddressPayload } from 'src/app/models/customer-address/return-generic-address-payload';
import { SearchResultCustomerAddressPayload } from 'src/app/models/customer-address/search-result-customer-address-payload';
import { ReturnMessage } from 'src/app/models/return-message';
import { PostFilterFields } from 'src/app/models/shared/post-filter-fields';

@Injectable({
  providedIn: 'root'
})
export class CustomerAddressService {

  private apis = {
    add: 'zmp_existingCustomerProspectCustomerAddress/Create/',
    update: 'zmp_existingCustomerProspectCustomerAddress/Update',
    addProspect: 'zmp_prospectCustomerAddress/Create/',
    updateProspect: 'zmp_prospectCustomerAddress/Update',
    getGeneric: 'mfqAppAddress/Get',
    getHeaderDetails: 'utility/GetCustomerAndAddressHeader',
    search: 'mfqAppAddress/Index/'
  };

  constructor(
    private http: HttpClient) { }

  search(data: PostFilterFields): Observable<ReturnMessage<SearchResultCustomerAddressPayload>> {
    return this.http.post<ReturnMessage<SearchResultCustomerAddressPayload>>(this.apis.search, data);
  }

  add(data: PostExistingCustomerProspectCustomerAddressCreate) {
    return this.http.post<ReturnMessage<ResponseCreateCustomerAddress>>(this.apis.add, data);
  }

  addProspect(data: PostProspectCustomerAddressCreate): Observable<ReturnMessage<ResponseCreateCustomerAddress>> {
    return this.http.post<ReturnMessage<ResponseCreateCustomerAddress>>(this.apis.addProspect, data);
  }

  update(data: PostProspectCustomerAddressUpdate) {
    return this.http.post<ReturnMessage<any>>(this.apis.update, data);
  }

  updateProspect(data: PostProspectCustomerAddressUpdate): Observable<ReturnMessage<any>> {
    return this.http.post<ReturnMessage<any>>(this.apis.updateProspect, data);
  }

  getGeneric(id: string, type: string): Observable<ReturnMessage<ReturnGenericAddressPayload>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
        .set('type', type)
    };
    return this.http.get<ReturnMessage<ReturnGenericAddressPayload>>(this.apis.getGeneric, options);
  }

  getHeaderDetails(id: string, type: string): Observable<ReturnMessage<CustomerAndAddressHeader>> {
    const options = {
      params: new HttpParams()
        .set('id', id)
        .set('type', type)
    };
    return this.http.get<ReturnMessage<CustomerAndAddressHeader>>(this.apis.getHeaderDetails, options);
  }
}
